import { axiosInstance } from "../../../utils";

const actions = {
  CREATE_OR_UPDATE_BLOG_REQUESTED: "CREATE_OR_UPDATE_BLOG_REQUESTED",
  CREATE_OR_UPDATE_BLOG_SUCCEEDED: "CREATE_OR_UPDATE_BLOG_SUCCEEDED",
  CREATE_OR_UPDATE_BLOG_FAILED: "CREATE_OR_UPDATE_BLOG_FAILED",

  addOrUpdateBlog: (data = undefined) => {
    return {
      type: actions.CREATE_OR_UPDATE_BLOG_REQUESTED,
      payload: data,
    };
  },

  createOrUpdateBlog: async (data = undefined) => {
    let url = `blogs/create`;

    let bodyFormData = new FormData();

    if (data.item_ids)
      bodyFormData.set("item_ids", JSON.stringify(data.item_ids));
    if (data.cover) bodyFormData.append("cover", data.cover);
    if (data.category_path)
      bodyFormData.append("category_path", data.category_path);
    if (data.main_image) bodyFormData.append("main_image", data.main_image);
    if (data.video_url) bodyFormData.append("video_url", data.video_url);
    if (data.video_image) bodyFormData.append("video_image", data.video_image);
    if (data.author_image)
      bodyFormData.append("author_image", data.author_image);
    if (data.author) bodyFormData.set("author", JSON.stringify(data.author));
    if (data.title) bodyFormData.set("title", data.title);
    if (data.title_ar) bodyFormData.set("title_ar", data.title_ar);
    if (data.body) bodyFormData.set("body", data.body);
    if (data.body_ar) bodyFormData.set("body_ar", data.body_ar);
    if (data.sections) {
      const sections = data.sections.map((section) => {
        return {
          ...section,
          item_ids: section.item_ids.join(","),
        };
      });
      bodyFormData.set("sections", JSON.stringify(sections));
    }
    console.log(data, "==bodyFormData");
    // if (data.brand_path) bodyFormData.set("brand_path", data.brand_path);

    if (data._id) {
      url = `blogs/` + data._id;
      try {
        const blog = await axiosInstance.put(url, bodyFormData);
        return blog.data;
      } catch (error) {
        throw error;
      }
    } else {
      try {
        const blog = await axiosInstance.post(url, bodyFormData);
        return blog.data;
      } catch (error) {
        throw error;
      }
    }
  },
};

export default actions;
